import { useEffect } from "react";
import useUserStore from "../../stores/store";
import ApiService from "../../utils/ApiService";
import { useNavigate } from "react-router-dom";
import { useSocket } from "../../hooks/useSocket";
import { useClearSessionData } from "../../hooks/useClearSessionData";
import { fetchAndUpdateTableFloors } from "../../services/order-table-base-service";
import { fetchAndstoreCoupons, storeCoupons } from "../../services/coupon-service";

/**
 * This component will called on first load and every reload
 * It will ensure that login session has proper data
 *
 *
 * @param {*} param0
 * @returns
 */
export default function LoginSessionDataUpdate({}) {
  const navigate = useNavigate();
  const socket = useSocket(`${process.env.REACT_APP_IMAGE_BASE_URL}`);
  const { restaurantSlug, restaurantId, updateSessionData, showNotification, setNetworkCall } = useUserStore();
  const clearSessionData = useClearSessionData();

  const updateProfileData = async () => {
    try {
      let authStorage = localStorage.getItem("auth-storage");

      if (!authStorage) {
        // No need to do anything here because it will be automatically redirected to login from other place but it can also be done here
        return;
      }

      
      authStorage = JSON.parse(authStorage);
      const { state } = authStorage;

      // A login user must have user and inside it, user id and token must exit in session (auth-storage)
      if (!state?.user || !state.user?.id || !state.user?.token || !state.user.token?.token) {
        return;
      }

      // Now it ensured that login session is valid and do the session update related works
      const isRestaurantSwitchEnabled = state.user?.isRestaurantSwitchEnabled || false;

      // Super admin.
      if (state.isSuperAdmin) {
        return;
      }

      if (isRestaurantSwitchEnabled) {
        // TODO when super admin operating restaurant by switching will need to update session data.
        return;
      }

      // Updating session data for normal users
      const resRestaurantInfo = await ApiService.GET_RESTAURANT_INFO({ restaurantId: state.restaurantId }, state.user.token.token);
      const { record } = resRestaurantInfo.payload;
      updateSessionData(record);
      //Update table management store
      if (record.tableManagement === 'Active') {
        fetchAndUpdateTableFloors(state.restaurantId, state.user.token.token);
      }

      // UPDATE COUPON LIST
      fetchAndstoreCoupons(state.restaurantId, state.user.token.token);

    } catch (error) {
      console.log("Error while updating profile data. Error:", error);
      showNotification("Failed to update your current session data. Please login again.")
      clearSessionData();
      navigate('/');
    }
  };

  useEffect(() => {
    setNetworkCall(false); // It will ensure if somehow this method set true but not set to false then on reload it will make it false
    updateProfileData();
  }, []);

  // Auto Print
  useEffect(() => {
    if (!socket || !restaurantSlug || !restaurantId) {
      return;
    }

    const eventName = `restaurant-profile-edited-${restaurantSlug}`;

    socket.on(eventName, (data) => {
      console.log(`Event:${eventName} received. data=`, data);
      updateSessionData(data);
    });

    const eventNameCoupon = `${restaurantId}-updated-coupon-dropdown`;
    socket.on(eventNameCoupon, (data) => {
      console.log(`Event:${eventName} received. data=`, data);
      storeCoupons(data.records);
    });

  }, [socket, restaurantSlug, restaurantId]);

  return <></>;
}
